import { Widget } from "./Widget";
import { WidgetState } from "./Widget";
import { SingleMetricContainerTemplateV2 } from "../dashboard/singleMetric/SingleMetricContainerTemplate-v2";

export class WWOWebRanksWidget extends Widget {
    static getWidgetMetadataType() {
        return "SingleMetric";
    }

    static getWidgetResourceType() {
        return "SingleMetric";
    }

    constructor() {
        super();
    }

    initWidget(widgetConfig, context) {
        super.initWidget(widgetConfig, context);
    }

    setMetadata() {}

    callbackOnGetData(response: any) {
        this.data = response.Data[Object.keys(response.Data)[0]];
    }

    validateData(response: any) {
        return true;
    }

    handleDataError(error: number) {
        //no error state
        this.widgetState = WidgetState.LOADED;
        super.handleDataError(error);
    }

    onResize() {}

    get templateUrl() {
        return `/app/components/widget/widget-templates/singlemetric.html`;
    }
    get templateComponent() {
        return SingleMetricContainerTemplateV2;
    }
}

WWOWebRanksWidget.register();
